export default "__VITE_ASSET__5dET8t_d__"